export default __webpack_public_path__ + "static/media/picto-trash.8f27649a.svg";